/* eslint-disable react/react-in-jsx-scope */
import react, { useEffect, useRef, useState } from 'react'
import { RhyBusButton as  Buttons} from '@rhybus/button'
// import Buttons from '../buttons/buttons'
// import './alert.css'
const Alert = (props: any) => {
    const [opacity, setOpacity] = useState('opacity-0')
 
    useEffect(() => {
        setOpacity('opacity-100')
    }, [])
 
    const cancel = () => {
        setOpacity('opacity-0')
        setTimeout(() => {
            props?.setShowAlert(false)
        }, 300)
    }
 
    const yes = () => {
        setOpacity('opacity-0')
        setTimeout(() => {
            props?.yes()
        }, 300)
    }
const messageRef:HTMLParagraphElement | null = null
 const handleRef = (ref:HTMLParagraphElement | null) => {
    const messageRef = ref
    if(messageRef){
        messageRef.focus()
    }
 }
 const headingpopupRef = useRef<HTMLHeadingElement | null>(null)
 const popupContainerRef = useRef<HTMLDivElement | null>(null)
 useEffect(() => {
   const handleTabKey = (e: KeyboardEvent) => {
     if (e.key !== 'Tab' || !popupContainerRef.current) return
     const focusableElements = Array.from(
       popupContainerRef.current.querySelectorAll<HTMLElement>(
         'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
       )
     )
     if (focusableElements.length === 0) return
     const firstElement = focusableElements[0]
     const lastElement = focusableElements[focusableElements.length - 1]
     if (e.shiftKey && document.activeElement === firstElement) {
       e.preventDefault()
       lastElement.focus()
     } else if (!e.shiftKey && document.activeElement === lastElement) {
       e.preventDefault()
       firstElement.focus()
     }
   }
   document.addEventListener('keydown', handleTabKey)
   return () => {
     document.removeEventListener('keydown', handleTabKey)
   }
 }, [])
    return (
        <>
        <div className='alertoverly'></div>
            <div className={`alertsmain text-center ${props?.className} ${opacity}`} ref={popupContainerRef}>
            {props?.title && <h2 className={props?.alerttextclass}  tabIndex={0} aria-label={props?.title} ref={headingpopupRef}>{props?.titleicon && <span className={props?.titleicon}></span>} {props.title}</h2>}
                <div className={props?.alerttextclass} aria-label={props?.message} ref={handleRef} tabIndex={0}>{props?.icon && <span className={props?.icon}></span>} {props?.message}</div>
                {(props?.yes || props?.cancel) && <div className="d-flex gap-2 pt-2 justify-content-center">
                {props?.yes && <Buttons
                        label={props?.yes}
                        className={props?.btn1className}
                        onClick = {() => props?.onClick(props?.yes)}
                        type="button" />}
                    {props?.cancel &&  <Buttons
                        label={props?.cancel}
                        className={props?.btn2className}
                        onClick = {() =>props?.onClick(props?.cancel)}
                        type="button" />}
                </div>}
            </div>
 
        </>
 
    )
}
export default Alert
 